import { getImage } from '../../../../utility'
import EvalRedirect from '../../../EvalRedirect/EvalRedirect'
import Image from '../../../UI/Image/Image'
import {
  StyledSuggestion,
  Name,
  Description,
  ImageWrapper,
  Content,
  FlexWrapper,
} from './Suggestion.Styled'
import getWireLabel from '../../../../helper/getWireLabel'


const Suggestion = ({ data, clickedCallback, input }) => {
  return (
    <StyledSuggestion>
      <EvalRedirect
        route={
          data.type === 'sleeve'
            ? `/detail/sleeve/${data.uuid}?input=${input}`
            : `/detail/${data.uuid}?input=${input}`
        }
        clickedCallback={clickedCallback}
      >
        <FlexWrapper>
          <ImageWrapper>
            {data.image && <Image maxHeight={'100%'} maxWidth={'100%'} src={getImage(data)} />}
          </ImageWrapper>
          <Content>
            <Name>
              {
                data.type === 'sleeve'
                ? data.product_name_shop
                : `${data.name} ...x${data.verseilelement}x${data.leiterdurchmesser || data.leiterdurchmesserinmm} 
                  ${data.betriebskapazittinnfkmbei800hz ? `(H${data.betriebskapazittinnfkmbei800hz.split(' ')[1]})` : ''} 
                  ${data.sibling && data.neualt === "neu"
                    ? `+ ...x${data.sibling.verseilelement}x${data.sibling.leiterdurchmesser || data.sibling.leiterdurchmesserinmm} 
                      ${data.sibling.betriebskapazittinnfkmbei800hz
                        ? `(H${data.sibling.betriebskapazittinnfkmbei800hz.split(' ')[1]})`
                        : ''}`
                    : ''}`
              }
            </Name>
            <Description>{data.description}</Description>
          </Content>
        </FlexWrapper>
      </EvalRedirect>
    </StyledSuggestion>
  )
}

export default Suggestion
